import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "isGuardian",
    "guardianNameContainer",
    "guardianFirstName",
    "guardianLastName",
  ]

  connect() {
    this.timeout = null;
    this.showOrHideGuardianName();
  }

  showOrHideGuardianName() {
    if (this.isGuardianTarget.checked) {
      this.guardianNameContainerTarget.classList.remove("hidden");
    } else {
      this.guardianNameContainerTarget.classList.add("hidden");
      // Clear whatever first/last name values we had.
      this.guardianFirstNameTarget.value = "";
      this.guardianLastNameTarget.value = "";
    }
  }

  onChange(e) {
    this.showOrHideGuardianName();

    if (!this.isGuardianTarget.checked) {
      // Clear whatever first/last name values we had.
      this.guardianFirstNameTarget.value = "";
      this.guardianLastNameTarget.value = "";
    }

    // Submit the form to save the changes, but don't submit too often (debounce).
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      console.log("submitting form");
      this.element.submit();
    }, 500);
  }
}